import React, {useEffect, useRef, useState} from "react"
import {Div, Text, Container, Col, Row} from "atomize";
import styled from "styled-components";
import Header from "../Components/Molecules/Header";
import {apiGet} from "../Api";
// import Heading from "../Components/Atoms/Heading";
import theme from "../Theme/Theme";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {addActivity} from "../redux/actions";
import {withRouter} from 'react-router-dom';
import Skeleton from "react-loading-skeleton";
import dayjs from 'dayjs';
import ActivitiesGroup from "../Components/Molecules/ActivitiesGroup";
import {baseUrl} from "../Constants/constants";
import SEO from "../Components/Atoms/SEO";
import ReactGA from "react-ga";

const Date = styled.p`
  color: ${theme.colors.grayDark};	
  font-family: Inter;	
  font-size: 11px;	
  font-weight: 600;	
  letter-spacing: 1.2px;	
  line-height: 16px;
`;

const Title = styled.h2`
	color: ${theme.colors.dark};	
  font-family: Inter;
  font-size: 42px;
  font-weight: bold;
  line-height: 58px;
  margin: 0 0 1rem 0;
`;

const Subtitle = styled.p`
  color: ${theme.colors.grayDark};
  font-family: Inter;	
  font-size: 14px;	
  font-weight: 500;	
  line-height: 24px;
  margin-top: 1rem;
  margin-bottom: -.5rem;
`;

const Heading = styled.div`
  background-color: white;
  max-width: 750px;
  margin-top: 3rem;
  @media (min-width: 767px) {
    padding: 3rem 3rem 0 3rem;
    margin-top: -6rem;
  }
`;

const Description = styled.p`
	color: ${theme.colors.dark};	
  font-family: Inter;
  font-size: 20px;
  line-height: 30px;
  margin: 2rem 0;
  @media (min-width: 767px) {
    padding: 0 3rem;
  }
`;

const Body = styled(Div)`
  @media (min-width: 767px) {
    padding: 0 3rem;
  }
  color: ${theme.colors.grayDark};	
	font-family: Inter;
	p {
    font-size: 16px;	
    line-height: 30px;
    margin: 1rem 0;
	}
	h1, h2, h3, h4, h5 {
	  margin: 2rem 0 1rem 0;
	}
	h1 {
    font-size: 28px;	
    line-height: 40px;
	}
	h2 {
    font-size: 24px;	
    line-height: 38px;
	}
	img {
	  width: 100%;
	  height: auto;
	}
	caption {
    width: 100%;
    display: flex;
    font-weight: 300;
    font-size: 16px;
    border-left: 1px solid ${theme.colors.grey};
    padding-left: 1rem;
    margin: .5rem 0 1.5rem;
  }
`;

function StoryPure(props) {
  ReactGA.pageview(window.location.pathname + window.location.search);

  const story = props.match.params.story;
  const [data, setData] = useState({});
  const [heroImgUrl, setHeroImgUrl] = useState(null);
  const ref = useRef(null);


  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`/node/story?filter[title]=${story}&include=field_banner_image,field_organization&jsonapi_include=1`);
      setData(result.data.data[0]);
      result.data.data[0].field_banner_image.uri && setHeroImgUrl(result.data.data[0].field_banner_image.uri.url);
    }

    fetchData();
  }, []);


  useEffect(() => {
    if (data.body && ref.current) {
      const body = ref.current;
      const images = body.getElementsByTagName("img");
      images.forEach(img => {
        if (img.dataset.caption) {
          // console.log(img.dataset.caption);
          let caption = document.createElement('caption');
          caption.innerHTML = img.dataset.caption;
          img.parentNode.insertBefore(caption, img.nextSibling);
        }
      });

      for (let c = body.getElementsByTagName("a"), a = 0; a < c.length; a++) {
        let b = c[a];
        b.getAttribute("href") && b.hostname !== props.location.hostname && (b.target = "_blank")
      }
    }
  }, [data, ref]);


  function formatDate(d) {
    if (!d) {
      return undefined;
    } else {
      d = dayjs(d);
      return d.format('MMM DD, YYYY')
    }
  }

  function formatHtml(html) {
    // console.log(html);
    html = html.replace(/\/sites\/default\/files\//g, `${baseUrl}/sites/default/files/`);
    html = html.replace(/http:\/\/olincoursestklsrwlcly\.devcloud\.acquia-sites\.com/g, "");
    return html;
  }

  return (
    <Div>
      <SEO
        title={data && data.title ? data.title : "Stories | Engineering for Humanity | Olin College of Engineering"}
        description={data && data.field_description ? data.field_description : null}
      />
      <Header
        pageTitle={null}
        heroImgUrl={heroImgUrl}
        link={{
          url: '/stories',
          text: 'Back to all stories'
        }}
        height={75}
      />
      <Container>
        <Heading>
          {data.field_date && data.field_organization &&
          <Date>{data.field_organization.name + ' | ' + formatDate(data.field_date)} </Date>
          }
          <Title> {data.title || <Skeleton height={'20px'}/>} </Title>
          {
            data.field_activities && data.field_activities.length &&
            <>
              <Subtitle>Activities</Subtitle>
              <ActivitiesGroup
                activities={data.field_activities}
                overflow={true}
              />
            </>
          }
        </Heading>
        <Description>
          {data.field_description || <Skeleton count={5}/>}
        </Description>
        {
          data.body &&
          <Body ref={ref} dangerouslySetInnerHTML={{__html: formatHtml(data.body.value)}}/>
        }
      </Container>
    </Div>
  )
}

class Story extends React.Component {
  render() {
    return (
      <StoryPure
        {...this.props}
      />
    )
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      addActivity: addActivity
    },
    dispatch
  );
};

export default withRouter(connect(
  null,
  mapDispatchToProps
)(Story));
